// @core/api/endpoints/subscription/delete_discount.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Delete discount
 * Deactivates a discount code. The code can no longer be applied but existing discounted subscriptions continue with their terms.
 */
export async function DeleteDiscount(
  discount_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/discounts/:discount_id`;
  requestPath = requestPath.replace(':discount_id', encodeURIComponent(discount_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
